import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { supportApi, type TicketsQueryParams } from '../api/support.api';

export const SUPPORT_KEYS = {
  all: ['support'] as const,
  tickets: (params: TicketsQueryParams) => [...SUPPORT_KEYS.all, 'tickets', params] as const,
  ticket: (id: string) => [...SUPPORT_KEYS.all, 'ticket', id] as const,
  stats: () => [...SUPPORT_KEYS.all, 'stats'] as const,
};

export function useTickets(params: TicketsQueryParams) {
  return useQuery({
    queryKey: SUPPORT_KEYS.tickets(params),
    queryFn: () => supportApi.getAll(params),
  });
}

export function useTicket(id: string) {
  return useQuery({
    queryKey: SUPPORT_KEYS.ticket(id),
    queryFn: () => supportApi.getById(id),
    enabled: !!id,
  });
}

export function useTicketStats() {
  return useQuery({
    queryKey: SUPPORT_KEYS.stats(),
    queryFn: supportApi.getStats,
  });
}

export function useReplyToTicket() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ id, content }: { id: string; content: string }) =>
      supportApi.reply(id, content),
    onSuccess: (_, { id }) => {
      queryClient.invalidateQueries({ queryKey: SUPPORT_KEYS.ticket(id) });
      queryClient.invalidateQueries({ queryKey: SUPPORT_KEYS.all });
    },
  });
}

export function useUpdateTicketStatus() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ id, status }: { id: string; status: string }) =>
      supportApi.updateStatus(id, status),
    onSuccess: (_, { id }) => {
      queryClient.invalidateQueries({ queryKey: SUPPORT_KEYS.ticket(id) });
      queryClient.invalidateQueries({ queryKey: SUPPORT_KEYS.all });
    },
  });
}
